import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { Checkbox, StepActions, PageHeader } from "@components/ui_v2";
import { RootState } from "@store/store";
import { PATHS_TOFU_V2 } from "@helpers/constantes";

const KV = ({ k, v }: { k: string; v: string }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", letterSpacing: "0.04em" }}>
      {k}
    </Typography>
    <Typography fontWeight={500}>{v}</Typography>
  </Box>
);

export const AccionistaConfirmacion = () => {
  const navigate = useNavigate();
  const shareholder = useSelector((state: RootState) => state.register.shareholder);
  const [confirmaDatos, setConfirmaDatos] = useState(false);

  const onBack = () => navigate(PATHS_TOFU_V2.consultaBuro.path);
  const onNext = () => navigate(PATHS_TOFU_V2.waitingRoom.path);

  return (
  <Box>
    <PageHeader
      eyebrow="Accionista mayoritario"
      title="Confirma los datos"
      subtitle="Revisa la información capturada del accionista mayoritario antes de continuar."
    />

    <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "background.paper", borderRadius: 2, p: 3, mb: 2 }}>
      <Typography fontWeight={700} sx={{ mb: 2 }}>
        {shareholder.name} {shareholder.first_lastname} {shareholder.second_lastname}
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
        <KV k="Correo" v={shareholder.email || "—"} />
        <KV k="Teléfono" v={shareholder.phone_number || "—"} />
        <KV k="Código postal" v={shareholder.address?.postal_code || "—"} />
        <KV k="Domicilio" v={`${shareholder.address?.street || "—"} ${shareholder.address?.no_ext || ""}`} />
      </Box>
    </Box>

    <Checkbox
      checked={confirmaDatos}
      onChange={setConfirmaDatos}
      label="Confirmo que los datos son correctos y declaro bajo protesta de decir verdad ser el accionista mayoritario de la empresa mencionada en esta solicitud."
    />

    <StepActions onBack={onBack} onNext={onNext} nextDisabled={!confirmaDatos} />
  </Box>
  );
};
